
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"34.424"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.1.013a.806.806 0 00-.475.225 6.288 6.288 0 00-1.1 1.8 7.471 7.471 0 00-.75 3.05 4.592 4.592 0 001.4 3.375 8.493 8.493 0 004.925 1.95 11.541 11.541 0 014.225 1.1 3.072 3.072 0 011.5 2.275.8.8 0 101.55-.35 4.872 4.872 0 00-2.225-3.3 12.569 12.569 0 00-4.85-1.325 7.019 7.019 0 01-4.025-1.525 2.82 2.82 0 01-.9-2.2 6.125 6.125 0 01.6-2.4 6.457 6.457 0 01.8-1.3A.8.8 0 0023.1.013zm4.75.8a.804.804 0 00.15 1.6 6.094 6.094 0 012.925.625c.925.525 1.7 1.413 1.875 3.45a.8.8 0 00.8.725 5.29 5.29 0 013.125.95 2.4 2.4 0 01.825 1.65 7.273 7.273 0 01-.7 3.5.808.808 0 001.5.6 8.686 8.686 0 00.8-4.275 4.153 4.153 0 00-1.375-2.675A5.717 5.717 0 0034.2 5.685a5.57 5.57 0 00-2.475-4.05A7.474 7.474 0 0028 .813h-.15zM7.125 3.985a.935.935 0 00-.1.025.8.8 0 00-.625.563.8.8 0 00.225.813l28.8 28.8a.813.813 0 101.15-1.15l-9.025-9.023H39.2a.8.8 0 00.8-.8v-6.4a.8.8 0 00-.8-.8h-3.85a.813.813 0 00-.325 0H31.35a.813.813 0 00-.325 0H19.55L7.775 4.235a.8.8 0 00-.65-.25zM.8 16.013a.8.8 0 00-.8.8v6.4a.8.8 0 00.8.8h21.6l-1.6-1.6H1.6v-4.8H16l-1.6-1.6zm20.35 1.6h9.25v4.8h-4.45zm10.85 0h2.4v4.8H32zm4 0h2.4v4.8H36z","fill":"#38470b"}})])
          )
        }
      }
    